import { render, staticRenderFns } from "./WxWorkConfig.vue?vue&type=template&id=c27df9e2&scoped=true&"
import script from "./WxWorkConfig.vue?vue&type=script&lang=js&"
export * from "./WxWorkConfig.vue?vue&type=script&lang=js&"
import style0 from "./WxWorkConfig.vue?vue&type=style&index=0&id=c27df9e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27df9e2",
  null
  
)

export default component.exports